import { createContext, useContext } from "react";

const DomainsContext = createContext(null)

const useDomainsContext = () => {
    return useContext(DomainsContext)
  }
  
  export { DomainsContext, useDomainsContext }